
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 305 342"}},[_c('path',{attrs:{"fill":"#1D1E1C","d":"M212.7 14.6H56.4c-19.8 0-35.8 16-35.8 35.8v241.1c0 19.8 16 35.8 35.8 35.8h192.2c19.8 0 35.8-16 35.8-35.8v-207l-71.7-69.9zm51.1 292.1c-3.9 3.9-9.2 6.3-15.2 6.3H56.4c-6 0-11.3-2.4-15.2-6.3-3.9-3.9-6.3-9.2-6.3-15.2v-241c0-6 2.4-11.3 6.3-15.2 3.9-3.9 9.2-6.3 15.2-6.3h144.8v32.6c0 17.9 14.5 32.3 32.4 32.3h36.6v197.7c-.1 5.9-2.5 11.2-6.4 15.1z"}}),_c('path',{attrs:{"fill":"#1D1E1C","d":"M199.5 192.2h-17.9c-1.1 0-1.9-.9-1.9-1.9v-67.7c0-1.1-.9-1.9-1.9-1.9h-50.5c-1.1 0-1.9.9-1.9 1.9v67.7c0 1.1-.9 1.9-1.9 1.9h-17.9c-1.1 0-1.3.6-.7 1.4l46.4 53.2c.7.8 1.8.8 2.5 0l46.4-53.2c.6-.8.3-1.4-.7-1.4z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      